<div style="display: flex; flex-direction: column; gap: 10px">
    <div
        style="display: flex; flex-direction: column; align-items: baseline"
        class="bg-gray-200 br-15 p-3"
    >
        <div style="margin-bottom: 10px">
            <h2 class="montserrat-medium text-gray-500">Campaign Details</h2>
        </div>
        <div style="width: 100%; display: flex; justify-content: space-between">
            <div
                *ngFor="let campaignDetailInfo of campaignDetailsInfo"
                class="campaign-details-info"
            >
                <span>{{ campaignDetailInfo?.title }}</span>
                <div style="display: flex; flex-direction: row; align-items: center">
                    <span
                        *ngIf="!loading && campaignDetailInfo?.title == 'Campaign Status'"
                        class="status"
                        [ngClass]="{
                            paused: campaignDetailInfo?.value == 'PAUSED',
                            'partially-live': campaignDetailInfo?.value == 'PARTIALLY LIVE',
                            live: campaignDetailInfo?.value == 'LIVE',
                            stopped: campaignDetailInfo?.value == 'STOPPED',
                            cancelled: campaignDetailInfo?.value == 'CANCELLED',
                            completed: campaignDetailInfo?.value == 'COMPLETED'
                        }"
                    >
                    </span>
                    <span style="font-weight: 500">{{ loading ? '—' : campaignDetailInfo?.value }}</span>
                </div>
            </div>
        </div>
    </div>
    <div style="display: flex; flex-direction: row; gap: 12px; align-items: stretch;">
        <div style="width: 33.3%" *ngFor="let campaignNumericalMetric of campaignNumericalMetrics">
            <div class="bg-gray-200 br-15 p-3" style="height: 100%; width: 100%;">
                <div
                    style="
                        display: flex;
                        flex-direction: column;
                        justify-content: flex-start;
                        gap: 7px;
                    "
                >
                    <div
                        style="
                            display: flex;
                            flex-direction: row;
                            align-items: center;
                            justify-content: space-between;
                            gap: 12px;
                        "
                    >
                        <span class="text-gray montserrat-bold">{{
                            campaignNumericalMetric?.title
                        }}</span>
                        <div
                            class="edit-btn d-flex align-items-center justify-content-center text-center bg-gray-500 text-primary"
                            style="width: 40px; height: 40px; border-radius: 20px"
                        >
                            <img
                                [src]="campaignNumericalMetric?.iconUrl"
                                alt="Wallet"
                                title="Wallet"
                            />
                        </div>
                    </div>
                    <h3 *ngIf="!loading && campaignNumericalMetric?.price != undefined" style="color: #2f3541">
                        {{
                            campaignNumericalMetric?.price.value
                                | currency: campaignNumericalMetric?.currencyCode
                        }}
                    </h3>
                    <div class="d-flex flex-column align-items-start">
                        <h3 *ngIf="!loading && campaignNumericalMetric?.price == undefined"
                            style="color: #2f3541; font-weight: 700; font-size: 2rem;" class="mb-1">
                            {{ campaignNumericalMetric?.value | number }}
                        </h3>

                        <div *ngIf="campaignNumericalMetric?.percentage != null && campaignNumericalMetric.percentage >= 0"
                            class="d-flex align-items-center">
                            <span style="color: #20c997; font-size: 14px; font-weight: 600; display: flex; align-items: center;">
                                <mat-icon style="font-size: 16px; width: 16px; height: 16px; margin-right: 2px;">
                                    arrow_upward
                                </mat-icon>
                                <span class="percentage-value">
                                    {{ campaignNumericalMetric.percentage | number:'1.0-2' }}%
                                </span>
                            </span>
                            
                            <span style="color: #6c757d; font-size: 14px; margin-left: 4px;">vs Est.</span>
                        </div>
                    </div>
                    <h3 *ngIf="loading" style="color: #2f3541; opacity: 0.5">
                        —
                    </h3>
                </div>
            </div>
        </div>
    </div>
</div>
